import { MouseEvent } from 'react'
import { useHistory } from 'react-router-dom'
import { useFirebase } from 'react-redux-firebase'

import { Button, ButtonProps } from '@material-ui/core'
import ExitIcon from '@material-ui/icons/ExitToApp'

import { uiId, signOutGapi, logToAnalytics } from 'modules'

import { useAuth } from 'hooks'
import { paths } from 'app/paths'

type Props = {
    buttonText: string
} & ButtonProps

export const SignOut = ({ variant = 'outlined', buttonText = 'Logout', ...props }: Props) => {
    const firebase = useFirebase()
    const { uid } = useAuth()
    const history = useHistory()

    const signOut = (e: MouseEvent) => {
        e.preventDefault()
        logToAnalytics('logout')
        signOutGapi(uid)
        // once promise is resolved, we redirect to login
        firebase.logout().then(() => {
            history.push(paths.login)
        })
    }

    if (!uid) return null

    return (
        <Button
            variant={variant}
            onClick={signOut}
            id={uiId('profile-sign-out')}
            {...props}
            startIcon={<ExitIcon />}
        >
            {buttonText}
        </Button>
    )
}
